
import { Vue, Component, Prop } from "vue-property-decorator";
import DownloadExport from "@/components/DownloadExport.vue";
import Parameter from "../components/Parameter.vue";
@Component({ components: { DownloadExport, Parameter } })
export default class Download extends Vue {
  @Prop({ required: true })
  id!: string;

  where: string[] = [];
}
